import PropTypes from 'prop-types';
import { commonPropTypes, refPropType, } from '../../interfaces/commonProps';
import { spacingPropTypes, } from '../../interfaces/layoutProps';
export const textFieldPropTypes = {
    autoComplete: PropTypes.string,
    disabled: PropTypes.bool,
    hint: PropTypes.string,
    extensionEnd: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    inputId: PropTypes.string.isRequired,
    inputMode: PropTypes.oneOf([
        'none',
        'text',
        'tel',
        'url',
        'email',
        'numeric',
        'decimal',
        'search',
    ]),
    inputRef: refPropType(),
    invalid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    list: PropTypes.string,
    max: PropTypes.string,
    maxLength: PropTypes.number,
    min: PropTypes.string,
    minLength: PropTypes.number,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    pattern: PropTypes.string,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    type: PropTypes.oneOf(['text', 'password', 'email', 'tel', 'number']),
    validationMessage: PropTypes.string,
    value: PropTypes.string,
    ...commonPropTypes,
    ...spacingPropTypes,
};
//# sourceMappingURL=TextField.types.js.map